// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

export default function initSwiperSliders() {
  const carouselSlider = document.querySelector('.simple-carousel');
  if (carouselSlider) {
    let carouselSwiper = new Swiper('.simple-carousel', {
      // slidesPerView: "auto",
      slidesPerView: 1,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    });
  }

  // Get all potential instaces of ll img gallery
  const gallerySlider = document.querySelectorAll('.gallery-carousel');
  // If carousel exists initialise swiper
  if (gallerySlider) {
    for (let i = 0; i < gallerySlider.length; i++) {
      // we loop through all even if is just one
      // add unique numbered class
      let imgSwiperItem = 'gallery-carousel-' + i;
      gallerySlider[i].classList.add(imgSwiperItem);

      // get the child nav buttons and add unique class number to later use for nav options
      let pagination = gallerySlider[i].querySelectorAll('.swiper-pagination');
      // no loop, it should always be 2 items no more.
      pagination[0].classList.add('swiper-pagination' + i);
      // pagination[1].classList.add('gallery-next-' + i);

      // now lets initialize the swiper
      let gallerySwiper = new Swiper('.' + imgSwiperItem, {
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination' + i,
          clickable: true,
        },
      });
    }
  }

  // Get all potential instaces of ll img gallery
  const testimonialSlider = document.querySelectorAll('.testimonials__slider');
  // If carousel exists initialise swiper
  if (testimonialSlider) {
    for (let i = 0; i < testimonialSlider.length; i++) {
      // we loop through all even if is just one
      // add unique numbered class
      let imgSwiperItem = 'testimonials__slider-' + i;
      testimonialSlider[i].classList.add(imgSwiperItem);

      // get the child nav buttons and add unique class number to later use for nav options
      let pagination = testimonialSlider[i].querySelectorAll('.swiper-pagination');
      // no loop, it should always be 2 items no more.
      pagination[0].classList.add('swiper-pagination' + i);
      // pagination[1].classList.add('gallery-next-' + i);

      // now lets initialize the swiper
      let gallerySwiper = new Swiper('.' + imgSwiperItem, {
        slidesPerView: 1,
        autoplay: {
          delay: 1500,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination' + i,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
        },
      });
    }
  }

  // functions for both front and gutenberg
  function initHomeSlider() {
    const homeSlider = document.querySelector('.home-slider');
    if (homeSlider) {
      const swiperWrapper = homeSlider.querySelector('.swiper-wrapper');
      let carouselSwiper = new Swiper('.home-slider', {
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        on: {
          init() {
            swiperWrapper.style.opacity = '1';
          },
        },
      });

      // carouselSwiper.on('init', function() {
      // 	swiperWrapper.style.opacity = "1";
      // });
    }
  }

  initHomeSlider();
}
